import { render } from "./notificationClose.vue?vue&type=template&id=dcf62a4e&scoped=true"
const script = {}

import "./notificationClose.vue?vue&type=style&index=0&id=dcf62a4e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dcf62a4e"]])

export default __exports__